/**
 * ColumnFilterPopover — Phase 4 Fix F.
 *
 * Excel-style per-column filter trigger. Click the funnel icon next to a
 * column header to open a popover with the filter inputs. The button has two
 * visual states:
 *   - inactive: muted filter outline
 *   - active: solid primary background + dot indicator
 *
 * The actual input widgets are passed in as `children` so each column can
 * render the right control (date range, multi-select, number range, etc).
 */
import React from "react";
import { Filter } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

export default function ColumnFilterPopover({
  active = false,
  testId,
  align = "start",
  className = "",
  contentClassName = "",
  width = 280,
  children,
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          data-active={active ? "true" : "false"}
          className={`relative inline-flex h-6 w-6 items-center justify-center rounded transition-colors ${
            active
              ? "bg-primary/15 text-primary hover:bg-primary/25"
              : "text-muted-foreground hover:bg-accent/60 hover:text-foreground"
          } ${className}`}
          aria-label="filter column"
        >
          <Filter className="h-3 w-3" />
          {active && (
            <span className="absolute -right-0.5 -top-0.5 h-1.5 w-1.5 rounded-full bg-primary" />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align={align}
        side="bottom"
        sideOffset={4}
        className={`p-3 ${contentClassName}`}
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
